module.exports = __webpack_public_path__ + "static/media/pharma benefits icon (active).ef6010ee.svg";